import { getCardTypeByValue } from "./card-types-selector";
import { CardValidationErrors } from "./validationErrors";
export var validateLuhn = function (cardNumber) {
    return (cardNumber
        .split('')
        .reverse()
        .map(function (digit) { return parseInt(digit, 10); })
        .map(function (digit, idx) { return (idx % 2 ? digit * 2 : digit); })
        .map(function (digit) { return (digit > 9 ? (digit % 10) + 1 : digit); })
        .reduce(function (accum, digit) { return (accum += digit); }) % 10 === 0);
};
export var isValidCardNumber = function (cardNumber, bypassLuhn) {
    if (!cardNumber) {
        return { valid: false, error: CardValidationErrors.emptyCardNumber };
    }
    var valid = { valid: true, error: "" };
    var rawCardNumber = cardNumber.replace(/\s/g, '');
    var cardType = getCardTypeByValue(rawCardNumber);
    if (cardType && cardType.lengths) {
        var doesCardNumberMatchLength = cardType.lengths.includes(rawCardNumber.length);
        if (doesCardNumberMatchLength) {
            if (bypassLuhn === true) {
                return valid;
            }
            var isLuhnValid = validateLuhn(rawCardNumber);
            if (isLuhnValid) {
                return valid;
            }
            return { valid: false, error: CardValidationErrors.luhnValidationMsg };
        }
    }
    return { valid: false, error: CardValidationErrors.invalidCardNumber };
};
